module.exports = __webpack_public_path__ + "img/bg-earth-day.13e21729.svg";